import {
    pubSubChatCommands,
    pubSubScreen,
    pubSubSearch,
    pubSubSettings,
} from '.'
import { SIDEBAR } from '..'
import { Settings } from '../../../types/state'
import { generateChatCommands } from '../../actions/chatCommands'
import { updateSettingsAndEmit } from '../../actions/settings'
import { videoViewModeHandlers } from '../../actions/videoViewModeControls'
import {
    searchAction,
    searchListAction,
    updateSettingsAction,
} from '../../actions/workerActions'
import {
    SIDEBAR_BREAKPOINT,
    SIDEBAR_MINUMUM_BREAKPOINT,
} from '../../components/styles/breakpoints'
import {
    ChatCommandEvent,
    SearchEvent,
    SettingsEvent,
} from '../../constants/enums'
import { getScreenState } from '../getState'
import { setVideoViewModeHandlers } from '../internal/videoViewModeControls'
import { setSidebarVisibilityState } from '../state.sidebar'

const setupChatCommandsSubscriptions = () => {
    return pubSubChatCommands.on(ChatCommandEvent.GENERATE_COMMANDS, (data) => {
        const { message, chatType, user } = data
        generateChatCommands(message, user, chatType)
    })
}

const setupSearchSubscriptions = () => {
    const unsubQuery = pubSubSearch.on(SearchEvent.QUERY, searchAction)
    const unsubList = pubSubSearch.on(SearchEvent.QUERY_LIST, searchListAction)
    return () => {
        unsubQuery()
        unsubList()
    }
}

const setupSettingsSubscriptions = () => {
    return pubSubSettings.on(SettingsEvent.SAVE, (settings) => {
        const mergedSettings = settings.map(
            <T extends keyof Settings, K extends keyof Settings[T]>(setting: {
                type: T
                key: K
                value: Settings[T][K]
            }) => {
                const mergedValue = updateSettingsAndEmit(setting)
                return { ...setting, value: mergedValue }
            },
        )
        updateSettingsAction(mergedSettings)
    })
}

// const debouncedFloaterCheck = debounce(checkAndRepositionOffscreenFloaters, 400)

const setupWindowSizeSubscriptions = () => {
    return pubSubScreen.on('state', () => {
        const { windowWidth } = getScreenState()
        const { show } = SIDEBAR.setting
        const calcShow = show
            ? windowWidth >= SIDEBAR_MINUMUM_BREAKPOINT
            : (show ?? windowWidth > SIDEBAR_BREAKPOINT)

        if (SIDEBAR.state.show !== calcShow) {
            setSidebarVisibilityState(calcShow)
        }

        // debouncedFloaterCheck()
    })
}

const setupVideoViewModeHandlers = () => {
    setVideoViewModeHandlers(videoViewModeHandlers)
    return () => setVideoViewModeHandlers(null)
}

export const setupSubscriptions = () => {
    const unsubChatCommands = setupChatCommandsSubscriptions()
    const unsubSearch = setupSearchSubscriptions()
    const unsubSettings = setupSettingsSubscriptions()
    const unsubWindowSize = setupWindowSizeSubscriptions()
    const unsubVideoViewModeHandlers = setupVideoViewModeHandlers()
    return () => {
        unsubChatCommands()
        unsubSearch()
        unsubSettings()
        unsubWindowSize()
        unsubVideoViewModeHandlers()
    }
}
